module.exports = __webpack_public_path__ + "img/2.6cd95d7.png";